import { useTranslation } from 'react-i18next';
import { ISpecificationItem } from '../types/interfaces';
import { useMediaQuery } from 'react-responsive';
import SectionHeader from '../../../components/SectionHeader';
import Button from '../../../components/buttons/Button';
import { useState } from 'react';
import VehicleModelSpecsEdit from '../../../app/pages/vehicleModels/VehicleModelSpecsEdit';
import useModuleTableHelpers from '../../../hooks/useModuleTableHelpers';
import { useParams } from 'react-router-dom';
import TableSkeleton from '../../../components/loaders/TableSkeleton';

export default function VehiclModelsEditSpecificationsTable({ variant }: { variant?: boolean }) {
  const [isEditing, setIsEditing] = useState(false)
  const { t, i18n } = useTranslation();
  const {modelId, variantId} = useParams()
  const isDesktop = useMediaQuery({ query: '(min-width: 1024px)' });

  const { apiData, apiDataLoading } = useModuleTableHelpers({
    route: `admin/${variant ? "variants" : "models"}/${variant ? variantId : modelId}/spec-value`,
    withBreadcrumb: true,
    breadcrumbTitle: t('links.specifications'),
    queryKey: 'specifications'
  });

  const tableHeaders = [{label: t("group")}, { label: t('name') }, { label: t('value') }];

  if(isEditing) return <VehicleModelSpecsEdit data={apiData} setIsEditing={setIsEditing} variant={variant} />

  if(apiDataLoading) return <TableSkeleton columns={5} />

  return (
    <SectionHeader
      title={t("specifications")}
      customStyle="last specs_section"
      rightComp={
        <div className="buttons">
          <Button onClick={() => setIsEditing(true)}>
            <span className="bold">{t('edit_specifications')}</span>
          </Button>
        </div>
      }
    >
      <div className={`table_container ${isDesktop && 'lessColumns'} hasPagination`}>
        <div className="table_header">
          {tableHeaders?.map((header, index) => (
            <span className={`head`} key={index}>
              {header.label}
            </span>
          ))}
        </div>
        <div className={`table_data ${(!apiData || apiData?.length === 0) && 'no_data'}`}>
          {apiData?.length > 0 ? (
            <>
              {(apiData as ISpecificationItem[])?.map((item, index) => (
                <div className="item has_logo vehicles" key={index}>
                  <div className="column">
                    <div className="capitalize">{item?.spec_group?.name?.[i18n.language as 'en' | 'ar'] || '-'}</div>
                  </div>
                  <div className="column">
                    <div className="capitalize">{item?.spec?.name?.[i18n.language as 'en' | 'ar'] || '-'}</div>
                  </div>
                  <div className="column">{item?.spec?.type === "checkbox" ? (item?.value?.en === "0" ? t("not_available") : t("available")) : item?.value?.[i18n.language as 'en' | 'ar'] || '-'}</div>
                </div>
              ))}
            </>
          ) : (
            <h6>{t("no_specifications")}</h6>
          )}
        </div>
      </div>
    </SectionHeader>
  );
}
